"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyFormatTypeToJSON = exports.SurveyFormatTypeFromJSONTyped = exports.SurveyFormatTypeFromJSON = exports.SurveyFormatType = void 0;
/**
 *
 * @export
 */
exports.SurveyFormatType = {
    Audio: 'AUDIO',
    Video: 'VIDEO',
    Display: 'DISPLAY',
    Multiple: 'MULTIPLE'
};
function SurveyFormatTypeFromJSON(json) {
    return SurveyFormatTypeFromJSONTyped(json, false);
}
exports.SurveyFormatTypeFromJSON = SurveyFormatTypeFromJSON;
function SurveyFormatTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyFormatTypeFromJSONTyped = SurveyFormatTypeFromJSONTyped;
function SurveyFormatTypeToJSON(value) {
    return value;
}
exports.SurveyFormatTypeToJSON = SurveyFormatTypeToJSON;
